import { useSelector } from "react-redux";

import { RootState } from "@/store/store";

import { UserInfo } from "@/models";

const useUserInfo = (): UserInfo => {

  const userInfo = useSelector(
    (state: RootState) => state.auth.auth.userInfo
  );

  return userInfo || new Object({
    id: '',
    username: '',
    email: '',
    firstName: '',
    lastName: '',
    permissions: [],
  }) as UserInfo;

};

export default useUserInfo;
